export const curadoria = {
  lista: {
    title: 'Tracks · Curation',
    description: 'Compose and manage learning tracks.',
    novaTrilha: 'New track',
    colTitulo: 'Title',
    colStatus: 'Status',
    colAtualizado: 'Updated at',
    abrir: 'Open editor',
    empty: 'No tracks created yet. Build your team’s first journey.',
  },
  criar: {
    title: 'New track',
    description: 'Define the metadata; the track starts as a draft, with no courses.',
    title_label: 'Title',
    objetivo_label: 'Objective',
    descricao_label: 'Description',
    emiteCert_label: 'Issues certificate',
    criar: 'Create track',
    sucesso: 'Track created.',
  },
  editor: {
    voltar: 'Back to tracks',
    title: 'Track editor',
    metadados: 'Metadata',
    salvar: 'Save metadata',
    salvo: 'Metadata saved.',
    emiteCertCongelado:
      'The certificate was locked at the first publication and can no longer be changed.',
    publicar: 'Publish',
    arquivar: 'Archive',
    republicar: 'Republish',
    publicado: 'Track published.',
    arquivado: 'Track archived.',
    atribuir: 'Assign',
    cursos: 'Courses in the track',
    cursosVazio: 'This track has no courses yet. Add the first one.',
    addCurso: '+ Course',
    moverCima: 'Move up',
    moverBaixo: 'Move down',
    removerCurso: 'Remove course',
    removerCursoConfirm: 'Remove this course from the track?',
    removerCursoDesc: 'The course still exists; it just leaves this track’s composition.',
    cursoRemovido: 'Course removed from the track.',
    ordemSalva: 'Order updated.',
  },
  prereq: {
    title: 'Prerequisites (Track → Track)',
    description:
      'Declare a track the learner should complete before this one (a warning, not a block).',
    selecione: 'Select a track',
    placeholder: 'Choose the prerequisite track',
    declarar: 'Declare prerequisite',
    sucesso: 'Prerequisite declared.',
    erroDuplicado: 'This prerequisite already exists.',
    erroAuto: 'A track cannot be a prerequisite of itself.',
  },
  seletor: {
    title: 'Add course',
    description: 'Only published courses can be part of the track.',
    empty: 'No published courses available.',
    adicionar: 'Add',
    jaNaTrilha: 'Already in track',
    adicionado: 'Course added to the track.',
    erroDuplicado: 'This course is already in the track.',
    erroArquivado: 'An archived course cannot be added to new tracks.',
  },
  atribuir: {
    title: 'Assign to learners',
    descTrilha: 'Assign this track to multiple learners with a common deadline.',
    descCurso: 'Assign this course to multiple learners with a common deadline.',
    alunos: 'Learners',
    buscarPlaceholder: 'Search by name or email...',
    selecionar: 'Select learners',
    nenhumResultado: 'No users found.',
    digiteParaBuscar: 'Type to search for users.',
    prazo: 'Deadline',
    prazoHint: 'A past date is accepted: the enrollment starts already overdue.',
    submeter: 'Assign',
    submeterN: 'Assign to {{count}}',
    resultadoTitle: 'Assignment result',
    resumo: '{{criadas}} created · {{atualizadas}} updated · {{falhas}} failed',
    colAluno: 'Learner',
    colDesfecho: 'Outcome',
    colMotivo: 'Reason / warning',
    outcomeCriada: 'Created',
    outcomeAtualizada: 'Updated',
    outcomeFalhou: 'Failed',
    avisoPrereq: 'Not yet completed: {{titulos}}',
    novaAtribuicao: 'New assignment',
  },
} as const;
